import { AutoComplete, AutoCompleteProps, Select, SelectProps } from 'antd';
import styled from 'styled-components';

export const StyledAutoComplete = styled(AutoComplete)<AutoCompleteProps>`
  &&.emp-ant-select {
    flex: 1 0 fit-content;
    background: rgba(0, 0, 0, 0.04);
    border-radius: 3px;

    .emp-ant-select-selector {
      display: flex;
      padding: 4px 8px 4px 6px;
      align-items: center;
      border-radius: 3px;
      background: rgba(0, 0, 0, 0.04);
      height: 28px;

      .emp-ant-select-selection-search {
        display: flex;
        align-items: center;

        .emp-ant-select-selection-search-input {
          color: rgba(0, 0, 0, 0.45);
          font-weight: 500;
          letter-spacing: -0.14px;
          height: 20px;
        }
      }
    }
  }
`;

export const OperatorSelect = styled(Select)<SelectProps>`
  &&.emp-ant-select {
    .emp-ant-select-selector {
      height: 28px;
      border-radius: 3px;
      border-color: rgba(0, 0, 0, 0.15);
      padding: 4px 8px;
      color: rgba(0, 0, 0, 0.88);

      .emp-ant-select-selection-item {
        font-size: 12px;
        font-weight: 500;
        line-height: 16px;
        letter-spacing: -0.12px;
        display: flex;
        align-items: center;
      }
    }
  }

  &.emp-ant-select-disabled.emp-ant-select:not(.emp-ant-select-customize-input)
    .emp-ant-select-selector {
    color: rgba(0, 0, 0, 0.25);
  }
`;
